export default __webpack_public_path__ + "static/media/ic_summary_cart.e74f61ed.png";